import { apiRequest } from "../Component/Utils/ApiHundler";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function VideoCodage(token, Status, ModelId, UpdateStatus) {
  const apiUrl = `${API_BASE_URL}/document/list/toreview`;

  return await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({ Status, ModelId, UpdateStatus })
  });
}